module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div data-playable-hook="player-container" dir="ltr" data-playable-dir="'+(props.direction)+'" tabindex="0" class="'+(props.styles.container)+'"></div>';return out;
} 
  };